import { Paper, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import React, { useMemo } from 'react';
import useIsKioskMode from '../util/useIsKioskMode';

export default function FormContainer({ children }) {
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isIframe = useMemo(() => window.self !== window.top, []);
  const isKioskMode = useIsKioskMode();
  if (isIframe || isKioskMode) return (children);
  return (
    <PaperBox sx={{ pb: 2, mb: 2 }} elevation={4} matchesSm={matchesSm}>
      {children}
    </PaperBox>
  );
}

const PaperBox = styled(Paper)((props) => ({
  padding: props.matchesSm ? '18px 18px 18px 18px' : '36px 36px 36px 36px',
  position: 'relative',
}));
